import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export function Reveal({ children, delay = 0, y = 40, className = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.05 });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

function Line({ text, delay }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.05 });
  return (
    <span className="reveal-line" ref={ref}>
      <motion.span
        initial={{ y: "110%" }}
        animate={inView ? { y: "0%" } : { y: "110%" }}
        transition={{
          duration: 1,
          delay,
          ease: [0.22, 1, 0.36, 1],
        }}
      >
        {text}
      </motion.span>
    </span>
  );
}

export function RevealLines({ lines = [], className = "", delayBase = 0 }) {
  return (
    <div className={className}>
      {lines.map((l, i) => (
        <Line key={i} text={l} delay={delayBase + i * 0.12} />
      ))}
    </div>
  );
}
